(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["skin-solutions-grid"] && !Shopify.designMode) return;
  try {
    
(function() {
  var section = document.querySelector('.skin-today-section');
  if (!section) return;

  var grid = section.querySelector('.skin-today__grid');
  var dotsContainer = section.querySelector('.skin-today__dots');
  if (!grid || !dotsContainer) return;

  var cards = Array.from(grid.querySelectorAll('.skin-today__card'));
  if (cards.length === 0) return;

  cards.forEach(function(_, i) {
    var dot = document.createElement('span');
    dot.className = 'skin-today__dot' + (i === 0 ? ' is-active' : '');
    dotsContainer.appendChild(dot);
  });

  var dots = Array.from(dotsContainer.querySelectorAll('.skin-today__dot'));

  grid.addEventListener('scroll', function() {
    var scrollLeft = grid.scrollLeft;
    var cardWidth = cards[0].offsetWidth + 16;
    var index = Math.round(scrollLeft / cardWidth);
    index = Math.max(0, Math.min(index, cards.length - 1));

    dots.forEach(function(d, i) {
      d.classList.toggle('is-active', i === index);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
